module.exports = __webpack_public_path__ + "img/路径 2268@2x.df9247ef.png";